export const isBrowserSupported: () => Promise<boolean> = () => {
  return import('../../helpers/SupportedFeaturesHelper')
    .then(({ SupportedFeaturesHelper }) => {
      return SupportedFeaturesHelper.getSupportedFeatures();
    })
    .then((supportedFeatures): Promise<boolean> => {
      return Promise.resolve(
        supportedFeatures.wasmSupport &&
        supportedFeatures.webcamAccess &&
        supportedFeatures.webcamAvailable &&
        supportedFeatures.webglRendering
      );
    });
};
